import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import Loading from "./components/Loading";
import Route from "./providers/Route";
import { LANDING_ROUTE } from "./shared/constants";
import { DASHBOARD_ROUTE } from "./shared/routes";
import DashboardView from "./views/DashboardView";
import LandingView from "./views/LandingView";

const App = () => {
  return (
    <Suspense fallback={<Loading size={30} />}>
      <Switch>
        <Route
          exact
          path={LANDING_ROUTE}
          component={LandingView}
          needAuth={false}
        />
        <div>
          <Route
            exact
            path={DASHBOARD_ROUTE}
            component={DashboardView}
            needAuth={false}
          />
        </div>
      </Switch>
    </Suspense>
  );
};

export default App;
